import { Option, SelectOption, SelectOptionGroup } from '@legacy/types/SelectorValues'

type prepareSelectorValuesForReactSelectSig = (options: Option[]) => SelectOption[]
// type prepareSelectorValuesForReactSelectGroupSig = (options: OptionGroup[]) => SelectOptionGroup[]
type prepareSelectorValuesSig = (options: Option[], groupBy?: string) => SelectOption[] | SelectOptionGroup[]

const prepareSelectorValuesForReactSelect: prepareSelectorValuesForReactSelectSig = (options) =>
  options.map((opt) => ({
    value: opt.value,
    label: opt.text,
  }))

const prepareParameterInfoForGroupedOptions = (groupBy: string, options: Option[]): SelectOptionGroup[] => {
  const optionObject: { [key: string]: SelectOptionGroup } = {}

  options.forEach((item) => {
    const key = item.data[groupBy]
    const option = {
      value: item.value,
      label: item.text,
    }

    // eslint-disable-next-line
    if (optionObject.hasOwnProperty(key)) {
      optionObject[key].options.push(option)
    } else {
      optionObject[key] = { label: key, options: [option] }
    }
  })

  return Object.values(optionObject)
}

export const prepareSelectorValues: prepareSelectorValuesSig = (options, groupBy) => {
  if (groupBy) {
    return prepareParameterInfoForGroupedOptions(groupBy, options)
  } else {
    return prepareSelectorValuesForReactSelect(options)
  }
}
